import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { FormModule } from '../../shared/components/default/form/form.module';
import { LanguageSwitcherComponent } from './language-switcher.component';
import { LanguageSwitcherConfirmDialogComponent } from './confirm-dialog/language-switcher-confirm-dialog.component';

@NgModule({
    declarations: [
        LanguageSwitcherComponent,
        LanguageSwitcherConfirmDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        TranslateModule,
        FormModule,
    ],
    exports: [
        LanguageSwitcherComponent,
    ]
})
export class LanguageSwitcherModule {}
